<template>
  <div class="top-section image-right !tw-m-0" :style="`background-color: var(--${vars.backgroundColor}) !important;`">
    <div class="container-default w-container">
      <div class="grid-2-columns _3fr---1fr">
        <div id="w-node-f76a71b9-f388-a812-ba7e-b0408ea0c59a-9e5c1e4e" class="inner-container _552px _100-mbl">
          <h1
            data-w-id="53108659-3125-55e1-a921-794ed4b17f2a"
            style="
              -webkit-transform: translate3d(0, 10%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);
              -moz-transform: translate3d(0, 10%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);
              -ms-transform: translate3d(0, 10%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);
              transform: translate3d(0, 10%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);
            "
            class="display-1 color-neutral-100 mg-bottom-32px"
            :style="`color: var(--${vars.titleColor}) !important;`"
          >
            {{ vars.titleText }}
          </h1>
          <p
            data-w-id="b98b16c8-e9dd-d039-8396-9d201b3a2ad5"
            style="
              -webkit-transform: translate3d(0, 10%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);
              -moz-transform: translate3d(0, 10%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);
              -ms-transform: translate3d(0, 10%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);
              transform: translate3d(0, 10%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);
            "
            class="color-neutral-400 mg-bottom-40px"
            v-for="(item, index) in descriptions"
            :key="index"
            :style="`color: var(--${vars.textColor}) !important;`"
          >
            {{ item.description }}
          </p>
          <div
            data-w-id="cc8185ab-ef5a-69bc-6b98-9c13e6fb01cd"
            style="
              -webkit-transform: translate3d(0, 10%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);
              -moz-transform: translate3d(0, 10%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);
              -ms-transform: translate3d(0, 10%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);
              transform: translate3d(0, 10%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);
            "
            class="buttons-row tw-pt-10"
          >
            <div v-for="(button, index) in buttons" :key="`button-${index}`" class="max-md:tw-w-full">
              <nuxt-link
                :to="button.link"
                :external="true"
                class="w-button"
                :class="`${button.type} ${index === 0 ? 'button-row' : null}`"
              >
                {{ button.label }}
              </nuxt-link>
            </div>
          </div>
        </div>
      </div>
      <div
        id="w-node-_5e110784-1fc0-16ce-de98-5d8a72c40693-9e5c1e4e"
        data-w-id="5e110784-1fc0-16ce-de98-5d8a72c40693"
        style="
          -webkit-transform: translate3d(32px, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);
          -moz-transform: translate3d(32px, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);
          -ms-transform: translate3d(32px, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);
          transform: translate3d(32px, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);
        "
        class="top-section-image-right---wrapper"
      >
        <img :src="vars.backgroundImage" loading="eager" :alt="vars.titleText" class="image-28" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'Integrations',

  mixins: [ComponentMixin],

  computed: {
    buttons() {
      return this.groupedVariables.buttons;
    },

    descriptions() {
      return this.groupedVariables.descriptions;
    },
  },
});
</script>
